import React, { useCallback, useEffect, useState, useMemo, useReducer, Fragment } from 'react'
import { Flex, Box } from 'reflexbox'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { useParams, useHistory, Link } from 'react-router-dom'

import Breadcrumb from 'components/Breadcrumb'
import Card from 'components/Card'
import Loader from 'components/Loader'
import Button from 'components/Button'
import { Title } from 'components/Typography'
import { CheckboxGroup, TextField } from 'components/Form'

import { reducer } from 'helpers/loadingReducer'
import { getPackagesBalance } from 'services/orders'
import { editGroup, getGroupInfo } from 'services/groups'

const Edit = () => {
  const [packages, setPackages] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [groupData, setGroupData] = useState({ name: '', packages: [] })
  const [requestStatus, dispatch] = useReducer(reducer, { isLoading: true, error: false })
  const { id: groupID } = useParams()
  const history = useHistory()

  const breadcrumbPath = useMemo(
    () => [
      {
        label: 'Grupo de beneficiários',
        link: '/prepaid-purchase/groups',
      },
      {
        label: groupData?.name,
        link: `/prepaid-purchase/groups/attribution/${groupData?.id}`,
      },
      {
        label: `Editar ${groupData?.name}`,
      },
    ],
    [groupData],
  )

  const initialValues = useMemo(
    () => ({
      name: groupData?.name,
      packages: groupData?.packages?.map(package_id => `${package_id}`),
    }),
    [groupData],
  )

  const handleSubmit = useCallback(values => {
    try {
      setIsSubmitting(true)
      const formattedData = {
        name: values.name,
        packages: values.packages.map(package_id => +package_id),
      }
      editGroup(groupID, formattedData)
      toast.success('Grupo editado com sucesso!')
      history.push('/prepaid-purchase/groups')
    } catch (e) {
      console.log(e)
      toast.error('Não foi possível editar o grupo no momento.')
    } finally {
      setIsSubmitting(false)
    }
  }, [])

  useEffect(() => {
    const getGroupData = async () => {
      try {
        const { data } = await getGroupInfo(groupID)
        setGroupData(data)
        dispatch({ type: 'success' })
      } catch (e) {
        console.log(e)
        dispatch({ type: 'error' })
      }
    }

    getGroupData()
  }, [])

  useEffect(() => {
    const getBalance = async () => {
      try {
        const { data } = await getPackagesBalance()

        const formattedData = data.data.map(plan => {
          return {
            label: `${plan.package}(${plan.balance})`,
            value: `${plan.id}`,
          }
        })

        setPackages(formattedData)
      } catch (e) {
        console.log(e)
        toast.error('Não foi possivel carregar os pacotes no momento!')
      }
    }

    getBalance()
  }, [])

  return (
    <Flex flexDirection='column' width={1}>
      <Breadcrumb children={breadcrumbPath} />
      <Title as='h3'>Editar grupo</Title>
      {requestStatus.isLoading ? (
        <Flex width={1} height={322} justifyContent='center'>
          <Loader />
        </Flex>
      ) : (
        <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
          <Card mt={24}>
            <Flex flexDirection='column'>
              <Form>
                <Box width={(1, '280px')}>
                  <TextField name='name' label='Nome do grupo' placeholder='Nome do grupo' />
                  <CheckboxGroup my={24} name='packages' label='Selecionar pacote de canais' options={packages} />
                </Box>
                <Flex width={(1, '584px')} justifyContent='space-between'>
                  <Button
                    as={Link}
                    to={`/prepaid-purchase/groups/attribution/${groupID}`}
                    type='button'
                    size='big'
                    outlined
                  >
                    Voltar
                  </Button>
                  <Button disabled={isSubmitting} type='submit' size='big'>
                    {isSubmitting ? <Loader /> : 'Salvar'}
                  </Button>
                </Flex>
              </Form>
            </Flex>
          </Card>
        </Formik>
      )}
    </Flex>
  )
}

export default Edit
